module.exports = __webpack_public_path__ + "7156bb5baf499cb97278facf9e9e1e29.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/lobster.svg
// module id = 92
// module chunks = 0